import { ISearchResponse } from '@sales-center/common'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, get } from '../services/crud'
import { ILocationType } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.locationType}`

export const getLocationTypes = createAsyncThunk<
  ILocationType[],
  void,
  { rejectValue: APIError }
>('locationTypes/get', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) {
    const payload: ISearchResponse<ILocationType> = await response.json()
    return payload.items
  }
  return thunkApi.rejectWithValue(await response.json())
})
